<!--
 * @Descripttion: 
 * @Author: Gavin
 * @version: 
 * @Date: 2020-07-27 19:52:48
 * @LastEditTime: 2020-12-17 20:44:25
--> 

<template>
  <div class="home-search-header-container">
    <a :href="url" class="home-logo">
      <md-icon name="home" svg></md-icon>
      <p>有赚</p>
    </a>
    <router-link :to="{name: 'search', params: {type: type}}" class="input-box">
      <md-icon name="search"></md-icon>
      <p>{{placeholder}}</p>
    </router-link>
  </div>
</template>

<script>
import '@/assets/svgIcon/home.svg'
import memory from '@/utils/memory'

export default {
  data() {
    return {
      url: `${memory.ade}media/ade-navigate-index.html`
    }
  },
  props: {
    type: {
      type: String,
      default: 'knowledge'
    },
    placeholder: {
      type: String,
      default: '输入关键字搜索'
    }
  }
}
</script>

<style lang="scss">
.home-search-header-container{
  height: 128px;
  display: flex;
  align-items: center;
  padding: 32px;
  box-sizing: border-box;

  .home-logo{
    width: 64px;
    text-align: center;
    margin-right: 24px;
    color: #636666;
    font-size: 22px;

    .md-icon{
      width: 36px;
      height: 36px;
      line-height: 36px;
    }
  }
  .input-box{
    flex: 1;
    height: 100%;
    border: 1px solid #E1E1E6;
    border-radius: 64px;
    padding-left: 24px;
    font-size: 24px;
    color: #949999;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    p{
      position: relative;

      &::before{
        content: '';
        display: inline-block;
        width: 1px;
        height: 12px;
        background-color: #E1E1E6;
        margin: 0 10px;
      }
    }
  }
}
</style>